import { HaaiError } from "../models/HaaiError";
import { isHaaiError } from "../functions/is-haai-error";

export class ErrorHandler {
  /**
   * @description Handler to verify if error it's haai error
   * @param {any} error received object
   * @return {HaaiError}
   */
  public static handleHttpError(error: any): HaaiError {
    if (isHaaiError(error?.error)) {
      return new HaaiError(error?.error);
    }
    return new HaaiError();
  }
}